import { useEffect } from "react";
import "./assets/scss/theme.scss";
import { initGA } from "./services/analytics";
import Routes from "./routes";

// Get the Google Analytics Measurement ID from environment variables or use a fallback
const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || "G-XXXXXXXXXX";

const App = () => {
  useEffect(() => {
    const savedTheme = localStorage.getItem("layoutMode");
    if (!savedTheme) {
      localStorage.setItem("layoutMode", "eclipse");
    }
    
    // Initialize Google Analytics
    if (GA_MEASUREMENT_ID && GA_MEASUREMENT_ID !== "G-XXXXXXXXXX") {
      initGA(GA_MEASUREMENT_ID);
    } else {
      console.warn("Google Analytics Measurement ID not configured");
    }
  }, []);

  return (

      <Routes />
  
  );
};

// force deploy

export default App;
